// extracted by mini-css-extract-plugin
module.exports = {"container":"About-module--container--tX9k8","iconBox":"About-module--iconBox--3jdLA","fadeIn":"About-module--fadeIn--3KCgR","cv":"About-module--cv--1TEhO"};